



















































































































import { Component, Vue, Prop, Inject } from "vue-property-decorator";
import type { CityFeature } from "@/@types/route-info/v2/v2.citys";

import RouteInfoV2CityTableHeader from "./route-info-v2-city-table-header.vue";
import IdCopyComponent from "@/components/app/id-copy-component.vue";
import MiniPoster from "@/components/app/shared/image/mini-poster.vue";
import BSettingDd from "@/components/app/shared/btn&dd/b-setting-dd.vue";
import StandartTable from "@/components/tables/standart-table.vue";

@Component({
  components: {
    RouteInfoV2CityTableHeader,
    IdCopyComponent,
    MiniPoster,
    BSettingDd,
    StandartTable,
  },
})
class RouteInfoV2CityList extends Vue {
  @Prop({ type: Array, default: () => [] }) citis!: CityFeature[];
  @Prop({ type: Boolean, default: false }) deleted!: boolean;
  @Inject("cityFolder") cityFolder!: string;

  formatDate(date?: Date) {
    if (!date) return "—";
    return new Date(date).toLocaleDateString();
  }

  async copyId(id: string) {
    await navigator.clipboard.writeText(id);
    this.$bvToast.toast("ID copied", {
      autoHideDelay: 1000,
      solid: true,
      variant: "success",
    });
  }

  getCityImage(city: CityFeature): { img: string; folder: string } {
    const fallback = { img: "", folder: this.cityFolder };
    if (!city.properties.src) return fallback;
    const src = city.properties.src;
    const map: Array<{ name: string; folder: string }> = [
      { name: "image", folder: `${this.cityFolder}/image/hd` },
      { name: "background", folder: `${this.cityFolder}/background/hd` },
      { name: "poster", folder: `${this.cityFolder}/poster/hd` },
      {
        name: "vertical_poster",
        folder: `${this.cityFolder}/vertical_poster/hd`,
      },
      {
        name: "horizontal_poster",
        folder: `${this.cityFolder}/horizontal_poster/hd`,
      },
    ];
    for (const item of map) {
      const val = (src as any)[item.name];
      if (val) return { img: val, folder: item.folder };
    }
    return fallback;
  }
}
export default RouteInfoV2CityList;
